import { Component, TemplateRef, ViewChild } from "@angular/core";
import { NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";
import { CommonService } from "../../services/common.service";
import { Helper } from "src/app/core/helpers/helper";
import { Subscription } from "rxjs";
import { DeleteModalComponent } from "../delete-modal/delete-modal.component";
import { SocketService } from "../../services/socket.service";

@Component({
  selector: "app-export-history-modal",
  templateUrl: "./export-history-modal.component.html",
  styleUrl: "./export-history-modal.component.scss",
  standalone: false
})
export class ExportHistoryModalComponent {
  exportHistoryList: Array<any> = [];

  exportHistorySubscription!: Subscription;

  @ViewChild("exportHistorymodal", { static: true }) exportHistorymodal!: TemplateRef<any>;
  @ViewChild("deleteOpenModal", { static: true }) deleteOpenModal!: DeleteModalComponent;

  constructor(public offcanvasService: NgbOffcanvas, private commonService: CommonService, public helper: Helper, private socketService: SocketService) {}

  /**
   * Opens the modal dialog and fetches the export history list based on the provided history type and export type.
   *
   * @param historyType The type of history to fetch.
   * @param exportType The type of export to filter the history list.
   */
  openModal(historyType: any, exportType: string = ""): void {
    this.closeModal();
    this.getExportHistoryList(historyType, exportType);
  }

  /**
   * Opens the export history modal dialog.
   */
  openExportHistoryModal(): void {
    this.offcanvasService.open(this.exportHistorymodal, { position: "end", panelClass: "modal-right-lg", backdrop: "static" })?.result.then(
      () => {
        // Handle close/dismiss result if needed
      },
      () => {
        // Handle dismiss reason if needed
      }
    );
  }

  /**
   * Closes the currently open modal dialog and unsubscribes from the export history subscription.
   */
  closeModal(): void {
    this.offcanvasService?.dismiss(this.exportHistorymodal);
    this.exportHistorySubscription?.unsubscribe();
  }

  /**
   * Fetches the export history list based on the provided history type and export type.
   * Subscribes to the export history updates via socket service.
   *
   * @param historyType The type of history to fetch.
   * @param exportType The type of export to filter the history list.
   */
  getExportHistoryList(historyType: any, exportType: string): void {
    let parameters: any = {};
    if (exportType) {
      parameters = { exportType: exportType };
    }

    this.commonService.getExportHistoryList(historyType, parameters).subscribe((response: any) => {
      if (response) {
        this.exportHistoryList = response.exportHistory;
        this.openExportHistoryModal();

        this.exportHistorySubscription = this.socketService.listener(this.helper.SocketEvents.EXPORT_HISTORY).subscribe((resData: any) => {
          if (resData) {
            const res: any = JSON.parse(resData);
            if (res.data?.exportHistoryStatus === this.helper.ExportHistoryStatusEnum.COMPLETED) {
              const exportHistory = this.exportHistoryList.find((x: any) => x._id === res.data?.exportHistory?.exportHistoryId);
              if (exportHistory) {
                exportHistory.uri = res.data?.exportHistory.url;
                exportHistory.status = res.data?.exportHistoryStatus;
              }
            }
          }
        });
      }
    });
  }

  /**
   * Opens the delete modal dialog for the specified export history ID.
   *
   * @param id The ID of the export history to delete.
   */
  openDeleteModal(id: string): void {
    this.deleteOpenModal.openModal(id);
  }

  /**
   * Deletes the export history for the specified ID and closes the delete modal dialog.
   *
   * @param id The ID of the export history to delete.
   */
  deleteExportHistory(id: string): void {
    this.commonService.deleteExportHistory(id).subscribe((response: any) => {
      if (response) {
        this.deleteOpenModal.closeModal();
        this.closeModal();
      }
    });
  }
}
